// extracted by mini-css-extract-plugin
export var fullWidthButton = "_nm-0";